import React, { useState } from 'react';
import {
  FaFilter,
  FaInfo,
  FaMap,
  FaReadme,
  FaCalendarCheck,
  FaFilePdf,
  FaSatelliteDish,
  FaBug,
  FaFileSignature,
  FaDrawPolygon,
  FaCloudSun,
} from 'react-icons/fa';
import { IoAppsOutline } from 'react-icons/io5';
import { ImLab } from 'react-icons/im';
import { Translator } from '../../components/i18n';

function FloatButtons({
  getInfosTalhoes,
  carregaModalFiltros,
  toggleFiltroPC,
  limpaFiltros,
  getAtvidades,
  getObs,
  getDocs,
  getSentinelData,
  handlePragas,
  getLogsTalhoes,
  selectAll,
  plugField,
}) {
  const [hideMenu, setHideMenu] = useState(true);
  const [menuLabel, setMenuLabel] = useState('');

  const plugfieldMenu = Translator({
    path: 'mapa.menu.plugfiled',
  });
  const logtalhaoMenu = Translator({
    path: 'mapa.menu.logtalhao',
  });
  const atividadesMenu = Translator({
    path: 'mapa.menu.atividades',
  });
  const observacoesMenu = Translator({
    path: 'mapa.menu.observacoes',
  });
  const croquiMenu = Translator({
    path: 'mapa.menu.croqui',
  });
  const infosMenu = Translator({
    path: 'mapa.menu.info',
  });
  const amostragemMenu = Translator({
    path: 'mapa.menu.amostragem',
  });
  const filtrosMenu = Translator({
    path: 'mapa.menu.filtros',
  });
  const assistMenu = Translator({
    path: 'mapa.menu.assists',
  });
  const sentinelHubMenu = Translator({
    path: 'mapa.menu.hub',
  });
  const doencasMenu = Translator({
    path: 'mapa.menu.doencas',
  });
  const talhoesMenu = Translator({
    path: 'mapa.menu.todostalhoes',
  });

  return (
    <ul className="floating-nav">
      <li
        onClick={plugField}
        onMouseEnter={() => {
          setMenuLabel(plugfieldMenu);
          setHideMenu(false);
        }}
        onMouseLeave={() => setHideMenu(true)}
        aria-hidden="true"
      >
        <FaCloudSun color="white" />
      </li>
      <li
        onClick={getLogsTalhoes}
        onMouseEnter={() => {
          setMenuLabel(logtalhaoMenu);
          setHideMenu(false);
        }}
        onMouseLeave={() => setHideMenu(true)}
        aria-hidden="true"
      >
        <FaFileSignature color="white" />
      </li>
      <li
        onClick={getAtvidades}
        onMouseEnter={() => {
          setMenuLabel(atividadesMenu);
          setHideMenu(false);
        }}
        onMouseLeave={() => setHideMenu(true)}
        aria-hidden="true"
      >
        <FaCalendarCheck color="white" />
      </li>
      <li
        onClick={getObs}
        onMouseEnter={() => {
          setMenuLabel(observacoesMenu);
          setHideMenu(false);
        }}
        onMouseLeave={() => setHideMenu(true)}
        aria-hidden="true"
      >
        <FaReadme color="white" />
      </li>
      <li
        onClick={limpaFiltros}
        onMouseEnter={() => {
          setMenuLabel(croquiMenu);
          setHideMenu(false);
        }}
        onMouseLeave={() => setHideMenu(true)}
        aria-hidden="true"
      >
        <FaMap color="white" />
      </li>
      <li
        onClick={getInfosTalhoes}
        onMouseEnter={() => {
          setMenuLabel(infosMenu);
          setHideMenu(false);
        }}
        onMouseLeave={() => setHideMenu(true)}
        aria-hidden="true"
      >
        <FaInfo color="white" />
      </li>
      <li
        onClick={toggleFiltroPC}
        onMouseEnter={() => {
          setMenuLabel(amostragemMenu);
          setHideMenu(false);
        }}
        onMouseLeave={() => setHideMenu(true)}
        aria-hidden="true"
      >
        <IoAppsOutline color="white" />
      </li>
      <li
        onMouseEnter={() => {
          setMenuLabel(filtrosMenu);
          setHideMenu(false);
        }}
        onMouseLeave={() => setHideMenu(true)}
        onClick={carregaModalFiltros}
        aria-hidden="true"
      >
        <FaFilter color="white" />
      </li>
      <li
        onClick={getDocs}
        onMouseEnter={() => {
          setMenuLabel(assistMenu);
          setHideMenu(false);
        }}
        onMouseLeave={() => setHideMenu(true)}
        aria-hidden="true"
      >
        <FaFilePdf color="white" />
      </li>
      <li
        onClick={getSentinelData}
        onMouseEnter={() => {
          setMenuLabel(sentinelHubMenu);
          setHideMenu(false);
        }}
        onMouseLeave={() => setHideMenu(true)}
        aria-hidden="true"
      >
        <FaSatelliteDish color="white" />
      </li>
      <li
        onClick={handlePragas}
        onMouseEnter={() => {
          setMenuLabel(doencasMenu);
          setHideMenu(false);
        }}
        onMouseLeave={() => setHideMenu(true)}
        aria-hidden="true"
      >
        <FaBug color="white" />
      </li>
      <li
        onClick={selectAll}
        onMouseEnter={() => {
          setMenuLabel(talhoesMenu);
          setHideMenu(false);
        }}
        onMouseLeave={() => setHideMenu(true)}
        aria-hidden="true"
      >
        <FaDrawPolygon color="white" />
      </li>
      <li
        className="label-menu"
        onClick={getInfosTalhoes}
        aria-hidden="true"
        hidden={hideMenu}
      >
        <p className="txt-shadow">
          <strong>{menuLabel}</strong>
        </p>
      </li>
    </ul>
  );
}

export default FloatButtons;
